import styled from "styled-components";
import { IMG_WALLET_CARD_BG, SyncFilled } from '@assets';

export const Container = styled.div`
	display: flex;
	padding: 8px 0;
	border-radius: 8px;
	background-image: url(${IMG_WALLET_CARD_BG});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
`;

export const ActionButton = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	padding: 0 30px;
	cursor: pointer;

	:first-child {
		flex: 1;
		padding: 0 8px;
		flex-direction: row;
		gap: 4px;
	}

	:nth-child(2) {
		border-left: 1px solid rgba(0, 0, 0, 0.20);
		border-right: 1px solid rgba(0, 0, 0, 0.20);
	}

	@media screen and (max-width: 390px) {
		svg {
			width: 20px;
		}
	}
`;

export const Text = styled.div`
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #fff;

	@media screen and (max-width: 390px) {
		font-size: 10px;
	}

	@media screen and (max-width: 340px) {
		padding-left: 0;
	}

	@media screen and (max-width: 340px) {
		font-size: 9px;
	}
`;

export const BalanceText = styled(Text)`
	flex: 1;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	text-align: left;
	padding: 0;
	position: relative;
`;

export const ReloadIcon = styled(SyncFilled)`
/* color: #e89e0c;
font-size: 18px; */
`;
